import React, { Suspense, useEffect } from 'react';
import TableSkeleton from '../../../components/TableSkeleton';
import ReorderTable from '../../../components/ReorderTable';
import { ExtExclusionsProvider, useExtExclusions } from '../../../contexts/extractions/ExtExclusionContext';
import QueryBuilder from './QueryBuilder';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmDialog from '../../../components/ConfirmDialog';
import Spinner from '../../../components/Spinner';
import { createExtExclusion, updateExtExclusion } from "../../../store/extExclusions/actions";
import { Button } from '../../../components/ui/button';
import { setOpenModal } from '../../../store/extVersions/actions';

const ExtExclusions = () => {
    const dispatch = useDispatch();
    const {
        table,
        columns,
        openAddModal,
        extExclusions,
        handleDelete,
        handleCloseModal,
        showDeleteConfirmationDialog,
        handleRowReorder,
        getRowId,
    } = useExtExclusions();

    const { loading, extExclusion, openModal } = useSelector((state) => state.ExtExclusions);
    const { columnListValues, fieldValueOptionsMap, extractionViewOnly } = useSelector((state) => state.Extractions);

    useEffect(() => {
        dispatch(setOpenModal(false));
        return () => {
            dispatch(setOpenModal(false));
        };
    }, [dispatch]);
    
    return (
        <>
            <div className="flex justify-between mb-4">
                <div className="text-lg font-semibold text-primary">
                    Please define the exclusions here
                </div>
                <Button onClick={openAddModal} disabled={extractionViewOnly}>
                    Add New Exclusion
                </Button>
            </div>

            
            <Suspense fallback={<TableSkeleton columns={5} rows={5} headers={["#", "Code", "Title", "Actions"]}/>}> 
                <ReorderTable
                    loading={loading}
                    table={table}
                    data={extExclusions || []}
                    columns={columns}
                    pagination={false}
                    enableRowReordering={true}
                    onRowReorder={handleRowReorder}
                    getRowId={getRowId}
                />
            </Suspense>

            {/* Single QueryBuilder handles both create and edit */}
            {openModal && (
                <QueryBuilder
                    options={columnListValues}
                    fieldDropdownOptions={fieldValueOptionsMap}
                    editMode={!!extExclusion}
                    triggerText={extExclusion ? "Edit" : "Add New Exclusion"}
                    titleText={extExclusion ? "Edit Exclusion" : "Add New Exclusion"}
                    nameLabel="Exclusion Name"
                    namePlaceholder="Enter Exclusion name"
                    createAction={createExtExclusion}
                    updateAction={updateExtExclusion}
                    data={extExclusion}
                    openModal={openModal}
                    disabled={extractionViewOnly}
                    saveInProgress={loading}
                />
            )}
            
            <Suspense fallback={<Spinner/>}>
                <ConfirmDialog
                    open={showDeleteConfirmationDialog}
                    confirmAction={handleDelete}
                    handleClose={e => handleCloseModal('delete')}
                    actionText="Delete"
                    descriptionText="Are you sure you want to delete this Exclusion?"
                />
            </Suspense>
        </>
    );
};

const ExtExclusionsPage = () => {
    return (
        <ExtExclusionsProvider>
            <ExtExclusions />
        </ExtExclusionsProvider>
    );
};

export default ExtExclusionsPage;